<template>
  <div class="suspend"
       v-show="show">
    <div class="m">
      <div class="to-top"
           @click="scrollTop"></div>
      <div v-if="tel">
        <a :href='`tel:${tel}`'
           class="tel"
           target="_top"
           v-if="!isNewApp"
           @click="gaTel"></a>
        <span v-else
              class="tel"
              @click="appTel(tel)"></span>
      </div>
      <a class="car"
         :href="suspendObj.link"
         target="_blank"
         v-if="(statusInfo.stocknum=='0'||saleStatus=='stop')&&suspendObj.img"
         @click="gaCar($event,suspendObj.link)">
        <img :src="suspendObj.img"
             alt="">
      </a>
    </div>
    <div class="pc">
      <div class="tel"
           v-if="tel">
        <i></i>
        <div class="right">
          <p>{{tel}}</p>
          <p>客服电话</p>
        </div>
      </div>
      <div class="car"
           v-if="(statusInfo.stocknum=='0'||saleStatus=='stop')&&suspendObj.title"
           @click="gaCar($event,suspendObj.link)">
        <a :href="suspendObj.link"
           target="_blank">
          <img :src="suspendObj.title"
               alt="">
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import XHR from '../api'
export default {
  name: 'Suspend',
  props: ['saleStatus', 'statusInfo'],
  data: () => ({
    tel: '',
    suspendObj: {},
    show: false,
    timer: '',
    isNewApp: false
  }),
  components: {
  },
  created () {
    // 获取客服电话号码
    XHR.getHandWork({
      type: 17,
      hid: 3862
    }).then(res => {
      const { status, data } = res.data
      if (!status) {
        this.tel = data[0].title
      }
    })
    // 获取下方按钮
    XHR.getHandWork({
      type: 2,
      hid: 3845
    }).then(res => {
      const { status, data } = res.data
      if (!status) {
        this.suspendObj = data[0]
      }
    })
  },
  mounted () {
    if (window.CHESPEED && window.CHEIOS) {
      this.isNewApp = true
    }
    window.onscroll = (e) => {
      const top = document.documentElement.scrollTop || document.body.scrollTop
      const screenTop = document.body.clientHeight
      if (top > screenTop) {
        this.show = true
      } else {
        this.show = false
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    gaTel (ev) {
      this.sendAnalytics('陕汽德龙X3000专题活动', '主页-客服电话', '')
    },
    appTel (telNum) {
      this.sendAnalytics('陕汽德龙X3000专题活动', '主页-客服电话', '')
      window.callNativeMethod('onDial', {
        tel: telNum
      })
    },
    gaCar (ev, link) {
      ev.preventDefault()
      this.sendAnalytics('陕汽德龙X3000专题活动', '主页-留资抽车模', '')
      window.location.href = link
    },
    // 回到顶部
    scrollTop () {
      // 清空上一次的定时器
      clearInterval(this.timer)
      const toTop = document.querySelector('.big-gift').offsetHeight
      this.timer = setInterval(() => {
        const top = document.documentElement.scrollTop || document.body.scrollTop
        const speed = Math.ceil((top - toTop) / 5)
        document.body.scrollTop = document.documentElement.scrollTop = top - speed
        if (top <= toTop) {
          clearInterval(this.timer)
        }
      }, 20)
    }
  }
}
</script>
<style lang="less" scoped>
.suspend {
  z-index: 1000;
  position: fixed;
  right: 0px;
  bottom: 116px;
  .pc {
    display: none;
  }
  .m {
    display: block;
    .tel {
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/tel-btn.png");
      width: 96px;
      height: 97px;
      display: block;
    }
    .car {
      display: block;
    }
    .to-top {
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/to-top-btn.png");
      width: 96px;
      height: 97px;
    }
  }
}
@media screen and (min-width: 751px) {
  .suspend {
    position: fixed;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    right: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    .pc {
      display: block;
    }
    .m {
      display: none;
    }
    .tel {
      background-size: cover;
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/suspend1.png");
      width: 200px;
      height: 98px;
      position: relative;
      display: flex;
      i {
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/tel-icon.png");
        width: 40px;
        height: 34px;
        position: absolute;
        top: 35px;
        left: 12px;
      }
      p {
        width: 142px;
        font-size: 20px;
        color: #f5cd94;
        position: absolute;
        top: 22px;
        left: 52px;
        font-weight: normal;
        border-bottom: 1px solid #f5cd94;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:last-child {
          border-bottom: none;
          top: 58px;
          font-size: 16px;
          text-align: center;
          letter-spacing: 3px;
        }
      }
    }
    .car {
      cursor: pointer;
      margin-top: 10px;
      background-size: cover;
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/suspend2.png");
      width: 200px;
      height: 91px;
      a {
        display: inline-block;
        background-size: cover;
        background-color: transparent;
        width: 176px;
        height: 67px;
        margin-top: 17px;
        margin-left: 14px;
      }
    }
  }
}
</style>
